module.exports = __webpack_public_path__ + "img/barcelo-pool-3.895f0583.jpg";